import { getActiveFilter } from '../../../features/data-types'
import { O } from '../../../features/ui'
import { useStateHooks } from '../../../state'
import { TableName } from '../../../tables'
import { firstItem, toList } from '../../../utils/listUtils'
import { useLoaders } from '../../common'
import { useSystemStateHooks } from '../../system'
import { CustomerType } from '../state/types'

export const useCustomerTypeLoaders = () => {
    const systemHooks = useSystemStateHooks()
    const { getList, find } = useStateHooks()

    const loaders = useLoaders()

    return (companyId = systemHooks.companyId) => {
        const findAllCustomerTypes = (active = false) => getList(TableName.CUSTOMER_TYPES, active) as CustomerType[]
    
        const findCustomerType = (id?: string, attr?: string) => find(TableName.CUSTOMER_TYPES, id, attr) as O<CustomerType>

        const loadAllCustomerTypes = async (active = false) => {
            const { loadMultiple } = loaders(companyId)
            const options = active ? getActiveFilter() : undefined
            const response = await loadMultiple(TableName.CUSTOMER_TYPES, options)
            return response.dataTypes as CustomerType[]
        }

        const loadCustomerType = (id: string, dbRequest = false) => {
            const { load } = loaders(companyId)
            return load(TableName.CUSTOMER_TYPES, id, dbRequest) as Promise<O<CustomerType>>
        }

        const loadCustomerTypeByName = async (
            name: string,
            dbRequest = false
        ) => {
            const { loadFiltered } = loaders(companyId)
            const customerTypes = await loadFiltered(TableName.CUSTOMER_TYPES, dbRequest, { name })
            return firstItem(customerTypes) as O<CustomerType>
        }

        const loadCustomerTypesWithProp = async (
            propName: string,
            dbRequest = false
        ) => {
            const { loadFiltered } = loaders(companyId)
            return loadFiltered(TableName.CUSTOMER_TYPES, dbRequest, undefined, undefined, toList(propName)) as Promise<CustomerType[]>
        }
        
        return {
            findAllCustomerTypes,
            findCustomerType,
            loadAllCustomerTypes,
            loadCustomerType,
            loadCustomerTypeByName,
            loadCustomerTypesWithProp
        }
    }
}
